import HttpResponse from "../../../utils/http/http.response";
import railyApiService from "../raily-api.service";
import CargoCompanyAddressFetchInitDataRequest from "./address/fetch-init-data/cargo-company-address-fetch-init-data.request";
import CargoCompanyAddressFetchInitDataResponse from "./address/fetch-init-data/cargo-company-address-fetch-init-data.response";
import cargoCompanyAddressListRequestFactory from "./address/list/cargo-company-address-list-request.factory";
import CargoCompanyAddressListRequest from "./address/list/cargo-company-address-list.request";
import CargoCompanyAddressListResponse from "./address/list/cargo-company-address-list.response";
import cargoCompanyAddressUpdateRequestFactory from "./address/update/cargo-company-address-update-request.factory";
import CargoCompanyAddressUpdateRequest, {
  CargoCompanyAddressUpdateRequestBody,
} from "./address/update/cargo-company-address-update.request";
import CargoCompanyAddressUpdateResponse from "./address/update/cargo-company-address-update.response";
import CargoCompanyAddRequest, {
  CargoCompanyAddRequestBody,
} from "./cargo-company/add/cargo-company-add-request";
import cargoCompanyAddRequestFactory from "./cargo-company/add/cargo-company-add-request.factory";
import CargoCompanyDetailsRequest from "./cargo-company/details/cargo-company-details.request";
import CargoCompanyDetailsResponse from "./cargo-company/details/cargo-company-details.response";
import cargoCompanyListRequestFactory from "./cargo-company/list/cargo-company-list-request.factory";
import CargoCompanyListRequest, {
  CargoCompanyListRequestQueryParams,
} from "./cargo-company/list/cargo-company-list.request";
import CargoCompanyListResponse from "./cargo-company/list/cargo-company-list.response";
import CargoCompanyCargoTaxiContractsRequest from "./cargo-taxi/contracts/cargo-company-cargo-taxi-contracts.request";
import CargoCompanyCargoTaxiContractsResponse from "./cargo-taxi/contracts/cargo-company-cargo-taxi-contracts.response";
import CargoCompanyDispatchAddRequest, {
  CargoCompanyDispatchAddRequestBody,
} from "./dispatch/add/cargo-company-dispatch-add-request";
import cargoCompanyDispatchAddRequestFactory from "./dispatch/add/cargo-company-dispatch-add-request.factory";
import CargoCompanyDispatchAddResponse from "./dispatch/add/cargo-company-dispatch-add-response";
import CargoCompanyDispatchDetailsRequest from "./dispatch/details/cargo-company-dispatch-details.request";
import CargoCompanyDispatchDetailsResponse from "./dispatch/details/cargo-company-dispatch-details.response";
import cargoCompanyDispatchListRequestFactory from "./dispatch/list/cargo-company-dispatch-list-request.factory";
import CargoCompanyDispatchListRequest, {
  CargoCompanyDispatchListRequestQueryParams,
} from "./dispatch/list/cargo-company-dispatch-list.request";
import CargoCompanyDispatchListResponse from "./dispatch/list/cargo-company-dispatch-list.response";
import cargoCompanyDispatchMultiListRequestFactory from "./dispatch/multi-list/cargo-company-dispatch-multi-list-request.factory";
import CargoCompanyDispatchMultiListRequest from "./dispatch/multi-list/cargo-company-dispatch-multi-list.request";
import CargoCompanyDispatchMultiListResponse from "./dispatch/multi-list/cargo-company-dispatch-multi-list.response";
import CargoCompanyDispatchUpdateRequest, {
  CargoCompanyDispatchUpdateRequestBody,
} from "./dispatch/update/cargo-company-dispatch-update-request";
import cargoCompanyDispatchUpdateRequestFactory from "./dispatch/update/cargo-company-dispatch-update-request.factory";
import CargoCompanyDispatchUpdateResponse from "./dispatch/update/cargo-company-dispatch-update-response";
import CargoCompanyDispatcherListRequest from "./dispatcher/list/cargo-company-dispatcher-list.request";
import CargoCompanyDispatcherListResponse from "./dispatcher/list/cargo-company-dispatcher-list.response";
import cargoCompanyPassengerListRequestFactory from "./passenger/list/cargo-company-passenger-list-request.factory";
import CargoCompanyPassengerListRequest from "./passenger/list/cargo-company-passenger-list.request";
import CargoCompanyPassengerListResponse from "./passenger/list/cargo-company-passenger-list.response";
import CargoCompanyAddressAddRequest, {
  CargoCompanyAddressAddRequestBody,
} from "./address/add/cargo-company-address-add.request";
import CargoCompanyAddressAddResponse from "./address/add/cargo-company-address-add.response";
import cargoCompanyAddressAddRequestFactory from "./address/add/cargo-company-address-add-request.factory";
import CargoCompanyOrderBillingsListRequest, {
  CargoCompanyOrderBillingsListQueryParams,
} from "./order-billings/list/cargo-company-order-billings-list.request";
import CargoCompanyOrderBillingsListResponse from "./order-billings/list/cargo-company-order-billings-list.response";
import cargoCompanyOrderBillingsListRequestFactory from "./order-billings/list/cargo-company-order-billings-list-request.factory";
import CargoCompanyOrderBillingsDownloadRequest, {
  CargoCompanyOrderBillingsDownloadQueryParams,
} from "./order-billings/download/cargo-company-order-billings-download.request";
import CargoCompanyOrderBillingsDownloadResponse from "./order-billings/download/cargo-company-order-billings-download.response";
import appConfig from "../../../../app.config";
import urlService from "../../../utils/url/url.service";
import authService from "../../../../modules/auth/common/auth.service";
import cargoCompanyOrderBillingsDownloadRequestFactory from "./order-billings/download/cargo-company-order-billings-download-request.factory";

const cargoCompanyApiService = () => {
  const getPassengerList = async (
    request: CargoCompanyPassengerListRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyPassengerListResponse> => {
    const url = `/cargo-companies/${request.companyUuid}/passengers`;

    const queryParams =
      cargoCompanyPassengerListRequestFactory.createQueryParams(request);

    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getDispatcherList = async (
    request: CargoCompanyDispatcherListRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyDispatcherListResponse> => {
    const url = `/cargo-companies/${request.companyUuid}/dispatchers`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getDispatchList = async (
    request: CargoCompanyDispatchListRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyDispatchListResponse> => {
    const url = `/cargo-companies/${request.cargoCompanyId}/dispatches`;

    const queryParams: CargoCompanyDispatchListRequestQueryParams =
      cargoCompanyDispatchListRequestFactory.createQueryParams(request);

    return railyApiService().get<CargoCompanyDispatchListResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getDispatchMultiList = async (
    request: CargoCompanyDispatchMultiListRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyDispatchMultiListResponse> => {
    const url = `/cargo-companies/dispatches`;

    const queryParams: CargoCompanyDispatchListRequestQueryParams =
      cargoCompanyDispatchMultiListRequestFactory.createQueryParams(request);

    return railyApiService().get<CargoCompanyDispatchMultiListResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getDispatchDetails = async (
    request: CargoCompanyDispatchDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyDispatchDetailsResponse> => {
    const url = `/cargo-companies/${request.cargoCompanyId}/dispatches/${request.dispatchId}`;

    return railyApiService().get<CargoCompanyDispatchDetailsResponse>({
      url,
      abortSignal,
    });
  };

  const dispatchAdd = (
    request: CargoCompanyDispatchAddRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyDispatchAddResponse> => {
    const url = `/cargo-companies/${request.companyId}/dispatches`;

    const body: CargoCompanyDispatchAddRequestBody =
      cargoCompanyDispatchAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const dispatchUpdate = (
    request: CargoCompanyDispatchUpdateRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyDispatchUpdateResponse> => {
    const url = `/cargo-companies/${request.companyId}/dispatches/${request.dispatchId}`;

    const body: CargoCompanyDispatchUpdateRequestBody =
      cargoCompanyDispatchUpdateRequestFactory.createBody(request);

    return railyApiService().put({
      url,
      abortSignal,
      body,
    });
  };

  const cargoCompanyAdd = (
    request: CargoCompanyAddRequest,
    abortSignal: AbortSignal,
  ): Promise<HttpResponse> => {
    const url = `/cargo-companies`;

    const body: CargoCompanyAddRequestBody =
      cargoCompanyAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const getCargoCompanyList = (
    request: CargoCompanyListRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyListResponse> => {
    const url = `/cargo-companies`;

    const queryParams: CargoCompanyListRequestQueryParams =
      cargoCompanyListRequestFactory.createQueryParams(request);

    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getCargoCompanyDetails = (
    request: CargoCompanyDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyDetailsResponse> => {
    const url = `/cargo-companies/${request.cargoCompanyId}`;

    return railyApiService().get<CargoCompanyDetailsResponse>({
      url,
      abortSignal,
    });
  };

  const getAddressList = async (
    request: CargoCompanyAddressListRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyAddressListResponse> => {
    const url = `/cargo-companies/${request.companyUuid}/addresses`;

    const queryParams =
      cargoCompanyAddressListRequestFactory.createQueryParams(request);

    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  const addressAdd = (
    request: CargoCompanyAddressAddRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyAddressAddResponse> => {
    const url = `/cargo-companies/${request.cargoCompanyUuid}/addresses`;

    const body: CargoCompanyAddressAddRequestBody =
      cargoCompanyAddressAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const fetchCargoTaxiContractsListing = (
    request: CargoCompanyCargoTaxiContractsRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyCargoTaxiContractsResponse> => {
    const url = `/cargo-companies/${request.cargoCompanyUuid}/cargo-taxi/contracts`;
    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const fetchInitData = (
    request: CargoCompanyAddressFetchInitDataRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyAddressFetchInitDataResponse> => {
    const url = `/cargo-companies/${request.cargoCompanyUuid}/addresses/${request.addressUuid}`;
    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getCargoOrderBillingsList = (
    request: CargoCompanyOrderBillingsListRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyOrderBillingsListResponse> => {
    const url = `/cargo-companies/${request.cargoCompanyUuid}/order-billings`;

    const queryParams: CargoCompanyOrderBillingsListQueryParams =
      cargoCompanyOrderBillingsListRequestFactory.createQueryParams(request);

    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  const addressUpdate = (
    request: CargoCompanyAddressUpdateRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyAddressUpdateResponse> => {
    const url = `/cargo-companies/${request.cargoCompanyUuid}/addresses/${request.addressUuid}`;

    const body: CargoCompanyAddressUpdateRequestBody =
      cargoCompanyAddressUpdateRequestFactory.create(request);

    return railyApiService().put({
      url,
      abortSignal,
      body,
    });
  };

  const fetchReport = async (
    request: CargoCompanyOrderBillingsDownloadRequest,
    abortSignal: AbortSignal,
  ): Promise<CargoCompanyOrderBillingsDownloadResponse> => {
    const url = `/cargo-companies/${request.company_id}/order-billings/csv-dump`;

    const queryParams: CargoCompanyOrderBillingsDownloadQueryParams =
      cargoCompanyOrderBillingsDownloadRequestFactory.createQueryParams(
        request,
      );

    return railyApiService().getFile({
      url,
      abortSignal,
      queryParams,
    });
  };

  return {
    getPassengerList,
    getDispatcherList,
    getDispatchList,
    getDispatchMultiList,
    getDispatchDetails,
    dispatchAdd,
    dispatchUpdate,
    cargoCompanyAdd,
    getCargoCompanyList,
    getCargoCompanyDetails,
    getAddressList,
    addressAdd,
    fetchCargoTaxiContractsListing,
    fetchInitData,
    addressUpdate,
    getCargoOrderBillingsList,
    fetchReport,
  };
};

export default cargoCompanyApiService;
